import { Component, OnInit, ViewChild, ElementRef  } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { AddBandsService } from '../../../_services/brand/add-bands.service';

@Component({
  selector: 'app-edit-brands',
  templateUrl: './edit-brands.component.html',
  styleUrls: ['./edit-brands.component.css'],
  providers: [AddBandsService]
})
export class EditBrandsComponent implements OnInit {

  brandid: number;
  brand: any = {};
  cookies: Object;
  serviceprovider: any;
  constructor(
    private AddBandsService: AddBandsService,
    private activatedRoute: ActivatedRoute,
    private router:Router
  ) {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.brandid = params['id'];
      if (this.brandid != undefined) {
        Cookie.set('brandedit', '1');
      }
    });


    this.AddBandsService.editdetails(this.brandid).subscribe(
      res => {
        this.brand = res;
       var brands_l = this.brand.service_provider_type_id;
       this.brand.service_provider_type_id = brands_l.split(',');
        console.log(res);
      }
    );

    this.AddBandsService.getServiceProviderType().subscribe(
      res => {
        this.serviceprovider = res;
      }
    );
  }

  ngOnInit() {
  }

  @ViewChild('update_brand') update_brand:ElementRef;
  editBrand() {
  //  console.log(serviceprovider);
    this.update_brand.nativeElement.disabled = true;
    this.AddBandsService.editbrands(this.brand).subscribe(
      res => {
       this.router.navigate(['brands']);
      }
    )
  }

}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/_components/brands/edit-brands/edit-brands.component.ts